export default "__VITE_ASSET__KaYM$hlG__"